import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ChartDataset, ChartOptions } from 'chart.js';
import { AlertService } from 'src/app/services/alert.service';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util.service';
import { BaseChartDirective } from 'ng2-charts';
import { NotificationsComponent } from '../notifications/notifications.component';

@Component({
    selector: 'app-graph',
    templateUrl: './graph.component.html',
    styleUrls: ['./graph.component.scss'],
    imports: [BaseChartDirective, NotificationsComponent]
})
export class GraphComponent implements OnInit,AfterViewInit {

  @ViewChild('myCanvas') canvas!: ElementRef;

  constructor(private api:ApiService, public util:UtilService, private alertService: AlertService) {   }
  ngAfterViewInit(): void {
    let gradient = this.canvas.nativeElement.getContext('2d').createLinearGradient(0, 0, 0, 600);

    gradient.addColorStop(0, 'rgba(41, 171, 226, 0.65)');
    gradient.addColorStop(1, 'rgba(41, 171, 226, 0.25)');
    this.lineChartData = this.lineChartData.map((dataset) => ({
      ...dataset,
      backgroundColor: gradient,
      borderColor: '#29abe2',
    }));

  }

  lineChartData: ChartDataset<'line'>[] = [
    {
      data: [],
      label: 'Uploads',
      fill: true,
      tension: 0.4,
      borderWidth: 3,
      pointRadius: 5,
      pointHoverRadius: 6,
      pointBackgroundColor: '#8ccdea',
      pointBorderColor: '#29abe2',
      pointBorderWidth: 2,
      backgroundColor: 'rgba(41, 171, 226, 0.35)',
      borderColor: '#29abe2',
    },
  ];

  //Labels shown on the x-axis
  lineChartLabels: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

  // Define chart options
  lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
    },
    scales: {
      x: {
        grid: {
          color: 'rgba(0, 0, 0, 0.10)',
        },
        title: {
          display: true,
          text: 'Date'
        }
      },
      y: {
        grid: {
          color: 'rgba(0, 0, 0, 0.10)',
        },
        title: {
          display: true,
          text: 'Number of Uploads'
        },
        beginAtZero: true,
        suggestedMin: 0,
        suggestedMax: 7,
        ticks: {
          stepSize: 1,
          precision: 0
        }
      }
    }
  };

    
  

  createDates(res: any) {
    const { domainValues } = res;
    const now = new Date();

    return [...Array(now.getDate() + 1).keys()].filter(d => {
      return !domainValues.includes(d);
    });
  }

  createValues(res: any) {
    const dates = this.createDates(res).slice(1);
    let vals: any = [];

    dates.map(d => {
      vals.push({
        date: d,
        value: 0,
      });
    });

    return vals.sort((a: any, b: any) => {
      let aDate = a.date;
      let bDate = b.date;
      return aDate < bDate ? -1 : aDate > bDate ? 1 : 0;
    });
  }

  ngOnInit(): void {
    this.api.fetchUserActivity().subscribe((res: any) => {
      //{"maxActivity":4,"domainValues":[10,11],"coordinateMap":[[10,4],[11,1]]}

      let dateObjects = [...Array(7)].map((_, i) => {
        const d = new Date()
        d.setDate(d.getDate() - i)
        return d
      }).reverse();

      let labels: any = [];
      let values: any = [];

      let mappedCM:any = {}
      for (let j = 0; j < res.coordinateMap.length; j++){
        mappedCM[res.coordinateMap[j][0]] = res.coordinateMap[j][1];
      }

      for (let i = 0; i < dateObjects.length; i++) {
        const dateObj = dateObjects[i];
        const day = dateObj.getDate();
        const month = dateObj.toLocaleString('default', { month: 'short' });
        labels[i] = `${month} ${day}`;
        values[i] = mappedCM[day]?mappedCM[day]:0;
      }
      this.lineChartLabels = labels;

      this.lineChartData = [
        {
          data: values,
          label: 'Uploads',
          fill: true,
          tension: 0.4,
          borderWidth: 3,
          pointRadius: 5,
          pointHoverRadius: 6,
          pointBackgroundColor: '#8ccdea',
          pointBorderColor: '#29abe2',
          pointBorderWidth: 2,
          backgroundColor: 'rgba(41, 171, 226, 0.35)',
          borderColor: '#29abe2',
        },
      ];
    }, error=>{
      console.log("error",error);
      this.alertService.toast('Failed to load user activity. Please try again later.');
    });
  }

}
